export enum ObjectType {
  Icon = 1,
  Text = 2,
  SvgFigure = 3,
  Image = 4,
  Line = 5,
}

export enum AnyObjectState {
  Rotate = 'rotate',
}

export enum TextState {
  Round = 'round',
  Edit = 'edit',
}

export enum ImageState {
  Crop = 'crop',
  RemoveBackground = 'remove-background',
  Filter = 'filter',
}

export const ObjectTypesLabels = {
  [ObjectType.Icon]: 'Иконка',
  [ObjectType.Text]: 'Текст',
  [ObjectType.SvgFigure]: 'Фигура',
  [ObjectType.Image]: 'Изображение',
  [ObjectType.Line]: 'Стрелка',
}
